
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30855',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30855",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55415",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8399",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11854",
  "I18n": "static-7.1681",
  "quartz": "static-1.7532",
  "quartz-config": "static-1.1310",
  "quartz-core": "static-1.6751",
  "react-dlb": "static-1.90",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.81",
  "reselect": "static-3.13",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.985",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55402",
  "feedback-utils": "static-1.55406",
  "forms-embed-utils-lib": "static-1.4828",
  "forms-utils-lib": "static-1.13172",
  "foundations-assets": "static-1.5249",
  "foundations-components": "static-1.8581",
  "foundations-theming": "static-1.4842",
  "hub-http": "static-1.6574",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12161",
  "icons": "static-2.695",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4161",
  "raven": "static-3.5925",
  "react": "static-7.199",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17089",
  "react-select-plus": "static-1.114",
  "react-utils": "static-2.5593",
  "react-virtualized": "static-2.108",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.509",
  "tinymce-plugins": "static-1.58323",
  "transmute": "static-2.97",
  "ui-images": "static-2.1265",
  "UIComponents": "static-3.8800",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3809",
  "quartz-webpack": "static-1.3756",
  "foundations-theming-specialty": "static-1.2558",
  "property-description-translator": "static-1.4187",
  "HeadJS": "static-2.805",
  "framer-motion": "static-1.80",
  "hs-test-utils-bend-plugin": "static-1.3510",
  "msw": "static-1.39",
  "msw-config": "static-1.9",
  "testing-library": "static-1.160",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4674",
  "jasmine-runner": "static-1.6812",
  "opentelemetry-fe-types": "static-1.145",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.889",
  "hubspotter-http": "static-1.4896",
  "mobile-manifest-mixins": "static-1.585",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.520",
  "quartz-auth": "static-1.1207",
  "quartz-head": "static-1.1197",
  "quartz-i18n": "static-1.1207",
  "quartz-routing": "static-1.962",
  "quartz-test": "static-1.1207",
  "quartz-tracking": "static-1.911",
  "trellis-components": "static-1.2828",
  "ui-fonts": "static-1.1116",
  "usage-tracker-container": "static-1-feat-usage-tracker-event-property.48",
  "usage-tracker-core": "static-1-feat-usage-tracker-event-property.48",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.253",
  "conversations-skeleton-state": "static-1.7597",
  "reference-resolvers": "static-1.8546",
  "sanitize-text": "static-1.8520",
  "PatternValidationJS": "static-1.3254",
  "ReduxMessenger": "static-2.10735",
  "outpost": "static-1.4502",
  "rpc-client-utils": "static-1.5029",
  "sanitize": "static-1.4835",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4850",
  "floating-ui": "static-1.64",
  "hs-story-utils": "static-1.9787",
  "react-aria": "static-1.73",
  "react-create-root-preference": "static-1.80",
  "tanstack-table": "static-1.62",
  "trellis-assets": "static-1.2809",
  "bend-plugin-foundations-theming": "static-1.3325",
  "foundations-theming-base": "static-1.3827",
  "stylex": "static-1.42",
  "hs-locale-management": "static-1.332",
  "csstype": "static-1.50",
  "web-vitals": "static-1.16",
  "ai-components-ui-library": "static-1.9836",
  "atom": "static-1.5444",
  "codemirror": "static-5.103",
  "content-assistance-lib": "static-1.8276",
  "ContentUtils": "static-1.69245",
  "data-token-picker": "static-1.16969",
  "file-manager-components": "static-1.24630",
  "FileManagerCore": "static-1.40129",
  "FileManagerLib": "static-1.40270",
  "frontend-preferences-client": "static-1.8284",
  "hub-http-contrib": "static-1.3390",
  "interframe": "static-3.5106",
  "layout-dnd-components": "static-1.13053",
  "layout-dnd-utils": "static-1.12028",
  "property-translator": "static-1.5744",
  "react-codemirror": "static-1.11006",
  "react-colorpicker": "static-2.10577",
  "reference-resolvers-lite": "static-1.8467",
  "rich-text-lib": "static-1.20394",
  "tinymce-data": "static-1.41294",
  "tinymce-themes": "static-1.57179",
  "ui-addon-emoji-picker": "static-1.10234",
  "ui-addon-sales-email": "static-1.5565",
  "ui-brand-identity-lib": "static-1.16682",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.10715",
  "hubspotter-http-shared-msw-handlers": "static-1.10713",
  "usage-tracker-session-replay": "static-1-feat-usage-tracker-event-property.48",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "trellis-theming": "static-1.1339",
  "tanstack-virtual": "static-1.39",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.439",
  "chirp-fetch": "static-1.2261",
  "stylex-utils": "static-1.149",
  "chatspot-core": "static-1.23309",
  "copilot-toolkit": "static-1.11949",
  "customer-data-objects-ui-components": "static-1.13393",
  "data-fetching-client": "static-1.10011",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5123",
  "ui-addon-video-player": "static-1.9052",
  "ui-coaching-tips": "static-1.29413",
  "usage-tracker": "static-1-feat-usage-tracker-event-property.48",
  "cms-field-types": "static-1.5174",
  "content-icons-ui": "static-1.2410",
  "integrations-lib": "static-1.17189",
  "customer-data-objects": "static-1.8054",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1888",
  "apollo-link-hub-http": "static-2.5008",
  "apollo-stack-hubspot": "static-3.95",
  "graphql": "static-1.90",
  "immer": "static-1.102",
  "immerable": "static-1.4508",
  "ui-addon-iframeable": "static-1.9442",
  "video-components-external": "static-1.12247",
  "video-data-lib": "static-1.35905",
  "breeze-artifacts-sdk": "static-1.547",
  "audio-components": "static-1.6425",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29894",
  "FileManagerImages": "static-1.37781",
  "foundations-components-legacy": "static-1.1606",
  "html-to-image": "static-1.62",
  "redux-toolkit": "static-1.79",
  "salesImages": "static-1.625",
  "ui-universal-auth": "static-1.9513",
  "urlinator": "static-1.4880",
  "video-components": "static-1.14249",
  "video-embed": "static-1.36739",
  "ts-schema": "static-1.4330",
  "ContentData": "static-1.69320",
  "layout-data-lib": "static-1.10353",
  "react-dnd-compat": "static-1.4978",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1909",
  "external-options-client-types": "static-1.4377",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7257",
  "hs-promise-utils": "static-1.5953",
  "inbound-db-properties-service-client": "static-1.4083",
  "NamespacedHubStyle": "static-2.9295",
  "growth-onboarding-confetti": "static-1.3428",
  "SharedI18nStrings": "static-1.184",
  "ui-addon-i18n": "static-1.11513",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5802",
  "magpie-types": "static-1.5262",
  "simple-logging-lib": "static-1.3415",
  "avatar-components": "static-1.2847",
  "customer-data-ui-utilities": "static-1.10194",
  "growth-onboarding-feedback-components": "static-1.6949",
  "flux-actions": "static-1.375",
  "hubspot-apollo-client": "static-1.5238",
  "integrations-error-boundary-lib": "static-1.14604",
  "integrations-tracking-lib": "static-1.5975",
  "laboratory-lib": "static-3.7516",
  "native-integrations-shared-strings": "static-1.8129",
  "redux-observable": "static-1.76",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10635",
  "unified-auth": "static-1.1027",
  "breeze-engine-chat-components": "static-1.866",
  "breeze-engine-core": "static-1.1166",
  "ably": "static-2.2",
  "highlight.js": "static-1.87",
  "pulse": "static-1.995",
  "navigation-messaging": "static-1.8268",
  "content-media-composition-data-lib": "static-1.13373",
  "content-media-compositions": "static-2.17380",
  "idb-keyval": "static-1.52",
  "media-bridge-lib": "static-1.19485",
  "nudge-client-utils": "static-1.3234",
  "unified-auth-core-lib": "static-1.1309",
  "social-insights-client-types": "static-1.22736",
  "advanced-menus-core": "static-1.15655",
  "advanced-menus-lib": "static-1.12507",
  "ExportDialog": "static-6.10743",
  "ui-memberships-settings-lib": "static-1.34948",
  "conditional-properties-service-client": "static-1.4053",
  "crm-pipelines-api-client-types": "static-1.4384",
  "fdsr-migration-layer": "static-1.376",
  "framework-builder-read-service-client": "static-1.4258",
  "framework-data-schema-quick-fetch": "static-1.7162",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3946",
  "persist-promise": "static-1.4066",
  "foundations-components-test-utils": "static-1.6064",
  "reactive-lib": "static-1.1084",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.697",
  "universal-page-editor-lib": "static-1.3375",
  "adobe-sign-auth-lib": "static-1.573",
  "ads-unified-auth-lib": "static-1.1596",
  "custom-vendor-connection-lib": "static-1.77",
  "google-sheets-integration-lib": "static-1.1135",
  "microsoft-drive-auth-lib": "static-1.275",
  "surveymonkey-integration-lib": "static-1.612",
  "slack-ui-library": "static-1.10761",
  "bend-plugin-pulse": "static-1.498",
  "event-emitter": "static-1.1321",
  "fast-json-patch": "static-1.71",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.2991",
  "nudge-renderer-utils": "static-1.3310",
  "onboarding-tours": "static-1.17223",
  "whisper-core-api": "static-1.7438",
  "fsm": "static-1.4117",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15654",
  "simple-menus-lib": "static-1.17171",
  "settings-ui-lib": "static-1.12887",
  "crm-record-cards-service-types": "static-1.3805",
  "location-customization-utils-lib": "static-1.10217",
  "getting-started-shared-tasks": "static-1.19358",
  "growth-data-modal": "static-1.5976",
  "growth-onboarding-next-action-utils": "static-1.2795",
  "navigation-components": "static-1.18941",
  "onboarding-tours-client": "static-1.5438",
  "onboarding-tours-utils": "static-1.1290",
  "ui-shepherd-tracker": "static-1.8016",
  "user-context": "static-1.5471",
  "react-flip-move": "static-1.79",
  "onboarding-data-sync-lib": "static-1.2629",
  "growth-onboarding-next-action-components": "static-1.2823",
  "user-context-client": "static-1.4872",
  "nest": "static-1.598",
  "getting-started-shared-tasks-store": "static-1.18476",
  "InboxConnectUtils": "static-4.15660",
  "meetings-connect-utils-lib": "static-1.7976",
  "onboarding-scopes": "static-1.6816"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30855",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55415",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8399",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11854",
  "I18n": "/I18n/static-7.1681",
  "quartz": "/quartz/static-1.7532",
  "quartz-config": "/quartz-config/static-1.1310",
  "quartz-core": "/quartz-core/static-1.6751",
  "react-dlb": "/react-dlb/static-1.90",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.81",
  "reselect": "/reselect/static-3.13",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.985",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55402",
  "feedback-utils": "/feedback-utils/static-1.55406",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4828",
  "forms-utils-lib": "/forms-utils-lib/static-1.13172",
  "foundations-assets": "/foundations-assets/static-1.5249",
  "foundations-components": "/foundations-components/static-1.8581",
  "foundations-theming": "/foundations-theming/static-1.4842",
  "hub-http": "/hub-http/static-1.6574",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12161",
  "icons": "/icons/static-2.695",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4161",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.199",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17089",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-utils": "/react-utils/static-2.5593",
  "react-virtualized": "/react-virtualized/static-2.108",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.509",
  "tinymce-plugins": "/tinymce-plugins/static-1.58323",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1265",
  "UIComponents": "/UIComponents/static-3.8800",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3809",
  "quartz-webpack": "/quartz-webpack/static-1.3756",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2558",
  "property-description-translator": "/property-description-translator/static-1.4187",
  "HeadJS": "/HeadJS/static-2.805",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3510",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.9",
  "testing-library": "/testing-library/static-1.160",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4674",
  "jasmine-runner": "/jasmine-runner/static-1.6812",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.145",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.889",
  "hubspotter-http": "/hubspotter-http/static-1.4896",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.520",
  "quartz-auth": "/quartz-auth/static-1.1207",
  "quartz-head": "/quartz-head/static-1.1197",
  "quartz-i18n": "/quartz-i18n/static-1.1207",
  "quartz-routing": "/quartz-routing/static-1.962",
  "quartz-test": "/quartz-test/static-1.1207",
  "quartz-tracking": "/quartz-tracking/static-1.911",
  "trellis-components": "/trellis-components/static-1.2828",
  "ui-fonts": "/ui-fonts/static-1.1116",
  "usage-tracker-container": "/usage-tracker-container/static-1-feat-usage-tracker-event-property.48",
  "usage-tracker-core": "/usage-tracker-core/static-1-feat-usage-tracker-event-property.48",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.253",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7597",
  "reference-resolvers": "/reference-resolvers/static-1.8546",
  "sanitize-text": "/sanitize-text/static-1.8520",
  "PatternValidationJS": "/PatternValidationJS/static-1.3254",
  "ReduxMessenger": "/ReduxMessenger/static-2.10735",
  "outpost": "/outpost/static-1.4502",
  "rpc-client-utils": "/rpc-client-utils/static-1.5029",
  "sanitize": "/sanitize/static-1.4835",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4850",
  "floating-ui": "/floating-ui/static-1.64",
  "hs-story-utils": "/hs-story-utils/static-1.9787",
  "react-aria": "/react-aria/static-1.73",
  "react-create-root-preference": "/react-create-root-preference/static-1.80",
  "tanstack-table": "/tanstack-table/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.2809",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3325",
  "foundations-theming-base": "/foundations-theming-base/static-1.3827",
  "stylex": "/stylex/static-1.42",
  "hs-locale-management": "/hs-locale-management/static-1.332",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.16",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9836",
  "atom": "/atom/static-1.5444",
  "codemirror": "/codemirror/static-5.103",
  "content-assistance-lib": "/content-assistance-lib/static-1.8276",
  "ContentUtils": "/ContentUtils/static-1.69245",
  "data-token-picker": "/data-token-picker/static-1.16969",
  "file-manager-components": "/file-manager-components/static-1.24630",
  "FileManagerCore": "/FileManagerCore/static-1.40129",
  "FileManagerLib": "/FileManagerLib/static-1.40270",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8284",
  "hub-http-contrib": "/hub-http-contrib/static-1.3390",
  "interframe": "/interframe/static-3.5106",
  "layout-dnd-components": "/layout-dnd-components/static-1.13053",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12028",
  "property-translator": "/property-translator/static-1.5744",
  "react-codemirror": "/react-codemirror/static-1.11006",
  "react-colorpicker": "/react-colorpicker/static-2.10577",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8467",
  "rich-text-lib": "/rich-text-lib/static-1.20394",
  "tinymce-data": "/tinymce-data/static-1.41294",
  "tinymce-themes": "/tinymce-themes/static-1.57179",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10234",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5565",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16682",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10715",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10713",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-feat-usage-tracker-event-property.48",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "trellis-theming": "/trellis-theming/static-1.1339",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.439",
  "chirp-fetch": "/chirp-fetch/static-1.2261",
  "stylex-utils": "/stylex-utils/static-1.149",
  "chatspot-core": "/chatspot-core/static-1.23309",
  "copilot-toolkit": "/copilot-toolkit/static-1.11949",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13393",
  "data-fetching-client": "/data-fetching-client/static-1.10011",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5123",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9052",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29413",
  "usage-tracker": "/usage-tracker/static-1-feat-usage-tracker-event-property.48",
  "cms-field-types": "/cms-field-types/static-1.5174",
  "content-icons-ui": "/content-icons-ui/static-1.2410",
  "integrations-lib": "/integrations-lib/static-1.17189",
  "customer-data-objects": "/customer-data-objects/static-1.8054",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1888",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5008",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.95",
  "graphql": "/graphql/static-1.90",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4508",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9442",
  "video-components-external": "/video-components-external/static-1.12247",
  "video-data-lib": "/video-data-lib/static-1.35905",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.547",
  "audio-components": "/audio-components/static-1.6425",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29894",
  "FileManagerImages": "/FileManagerImages/static-1.37781",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1606",
  "html-to-image": "/html-to-image/static-1.62",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "salesImages": "/salesImages/static-1.625",
  "ui-universal-auth": "/ui-universal-auth/static-1.9513",
  "urlinator": "/urlinator/static-1.4880",
  "video-components": "/video-components/static-1.14249",
  "video-embed": "/video-embed/static-1.36739",
  "ts-schema": "/ts-schema/static-1.4330",
  "ContentData": "/ContentData/static-1.69320",
  "layout-data-lib": "/layout-data-lib/static-1.10353",
  "react-dnd-compat": "/react-dnd-compat/static-1.4978",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1909",
  "external-options-client-types": "/external-options-client-types/static-1.4377",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7257",
  "hs-promise-utils": "/hs-promise-utils/static-1.5953",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4083",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9295",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3428",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11513",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5802",
  "magpie-types": "/magpie-types/static-1.5262",
  "simple-logging-lib": "/simple-logging-lib/static-1.3415",
  "avatar-components": "/avatar-components/static-1.2847",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10194",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6949",
  "flux-actions": "/flux-actions/static-1.375",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5238",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14604",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5975",
  "laboratory-lib": "/laboratory-lib/static-3.7516",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8129",
  "redux-observable": "/redux-observable/static-1.76",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10635",
  "unified-auth": "/unified-auth/static-1.1027",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.866",
  "breeze-engine-core": "/breeze-engine-core/static-1.1166",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.87",
  "pulse": "/pulse/static-1.995",
  "navigation-messaging": "/navigation-messaging/static-1.8268",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13373",
  "content-media-compositions": "/content-media-compositions/static-2.17380",
  "idb-keyval": "/idb-keyval/static-1.52",
  "media-bridge-lib": "/media-bridge-lib/static-1.19485",
  "nudge-client-utils": "/nudge-client-utils/static-1.3234",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1309",
  "social-insights-client-types": "/social-insights-client-types/static-1.22736",
  "advanced-menus-core": "/advanced-menus-core/static-1.15655",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12507",
  "ExportDialog": "/ExportDialog/static-6.10743",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34948",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4053",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4384",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.376",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4258",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7162",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3946",
  "persist-promise": "/persist-promise/static-1.4066",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6064",
  "reactive-lib": "/reactive-lib/static-1.1084",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.697",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3375",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.573",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1596",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.77",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1135",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.275",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.612",
  "slack-ui-library": "/slack-ui-library/static-1.10761",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.498",
  "event-emitter": "/event-emitter/static-1.1321",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2991",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3310",
  "onboarding-tours": "/onboarding-tours/static-1.17223",
  "whisper-core-api": "/whisper-core-api/static-1.7438",
  "fsm": "/fsm/static-1.4117",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15654",
  "simple-menus-lib": "/simple-menus-lib/static-1.17171",
  "settings-ui-lib": "/settings-ui-lib/static-1.12887",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3805",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10217",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19358",
  "growth-data-modal": "/growth-data-modal/static-1.5976",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2795",
  "navigation-components": "/navigation-components/static-1.18941",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5438",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1290",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8016",
  "user-context": "/user-context/static-1.5471",
  "react-flip-move": "/react-flip-move/static-1.79",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2629",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2823",
  "user-context-client": "/user-context-client/static-1.4872",
  "nest": "/nest/static-1.598",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18476",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15660",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7976",
  "onboarding-scopes": "/onboarding-scopes/static-1.6816"
}
};
